/**
 * @generated SignedSource<<d6842b49511848fe661526a00e2a0936>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type videoPageQuery$variables = {
  after?: string | null | undefined;
  count?: number | null | undefined;
  entityId: string;
  sectionIds?: ReadonlyArray<string | null | undefined> | null | undefined;
  videoLatestQueueName: string;
  videoShortQueueName: string;
};
export type videoPageQuery$data = {
  readonly oneLineMenu: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"entityOnelineMenuLiteQueueItemsEdge">;
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly section: {
    readonly advertZone: string | null | undefined;
  };
  readonly " $fragmentSpreads": FragmentRefs<"latestVideoQuery" | "videoHeaderDropdownMenuQuery" | "videoListQuery" | "videoShortCarousel">;
};
export type videoPageQuery = {
  response: videoPageQuery$data;
  variables: videoPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": 24,
    "kind": "LocalArgument",
    "name": "count"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "entityId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "sectionIds"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "videoLatestQueueName"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "videoShortQueueName"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "entityId",
        "variableName": "entityId"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  }
],
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "version",
      "value": 2
    }
  ],
  "kind": "ScalarField",
  "name": "advertZone",
  "storageKey": "advertZone(version:2)"
},
v3 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "name": "video_highlight_menu"
    }
  }
],
v4 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
],
v5 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v6 = {
  "kind": "Variable",
  "name": "sectionIds",
  "variableName": "sectionIds"
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlAlias",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "UrlRedirect",
  "kind": "LinkedField",
  "name": "urlRedirect",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "toUrl",
      "storageKey": null
    },
    (v7/*: any*/)
  ],
  "storageKey": null
},
v12 = [
  (v9/*: any*/),
  (v10/*: any*/),
  (v11/*: any*/)
],
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityUuid",
  "storageKey": null
},
v15 = [
  (v13/*: any*/),
  (v7/*: any*/)
],
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "Application",
  "kind": "LinkedField",
  "name": "application",
  "plural": false,
  "selections": (v15/*: any*/),
  "storageKey": null
},
v17 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Section",
      "kind": "LinkedField",
      "name": "fullSectionPath",
      "plural": true,
      "selections": (v15/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "parentSection",
      "storageKey": null
    }
  ],
  "type": "Section",
  "abstractKey": null
},
v18 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "flattenTypeIds",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LiveArticle",
      "kind": "LinkedField",
      "name": "liveArticle",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        },
        (v7/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Article",
  "abstractKey": null
},
v19 = [
  (v13/*: any*/)
],
v20 = {
  "kind": "InlineFragment",
  "selections": (v19/*: any*/),
  "type": "Section",
  "abstractKey": null
},
v21 = {
  "kind": "InlineFragment",
  "selections": [
    (v7/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v22 = {
  "kind": "InlineFragment",
  "selections": (v19/*: any*/),
  "type": "VideoSection",
  "abstractKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "PaywallType",
  "kind": "LinkedField",
  "name": "paywallTypes",
  "plural": true,
  "selections": [
    (v14/*: any*/),
    (v7/*: any*/)
  ],
  "storageKey": null
},
v24 = {
  "kind": "InlineFragment",
  "selections": [
    (v23/*: any*/)
  ],
  "type": "Article",
  "abstractKey": null
},
v25 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SectionSegmentV2",
      "kind": "LinkedField",
      "name": "sectionsV2",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "value",
          "plural": true,
          "selections": [
            (v8/*: any*/),
            (v20/*: any*/),
            (v21/*: any*/),
            (v22/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v24/*: any*/)
  ],
  "type": "Content",
  "abstractKey": "__isContent"
},
v26 = {
  "kind": "InlineFragment",
  "selections": [
    (v13/*: any*/),
    (v14/*: any*/),
    (v10/*: any*/),
    (v11/*: any*/),
    (v16/*: any*/),
    (v17/*: any*/),
    (v18/*: any*/),
    (v25/*: any*/)
  ],
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
},
v27 = [
  (v13/*: any*/),
  (v9/*: any*/)
],
v28 = {
  "kind": "InlineFragment",
  "selections": (v27/*: any*/),
  "type": "Section",
  "abstractKey": null
},
v29 = {
  "kind": "InlineFragment",
  "selections": (v27/*: any*/),
  "type": "VideoSection",
  "abstractKey": null
},
v30 = [
  {
    "alias": null,
    "args": (v4/*: any*/),
    "concreteType": "QueueItemConnection",
    "kind": "LinkedField",
    "name": "items",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "QueueItemsEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              (v28/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": (v27/*: any*/),
                "type": "Topic",
                "abstractKey": null
              },
              (v29/*: any*/),
              (v26/*: any*/),
              (v21/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": "items(first:20)"
  },
  (v7/*: any*/)
],
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "youtubeId",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "concreteType": "VideoSource",
  "kind": "LinkedField",
  "name": "videoSource",
  "plural": true,
  "selections": [
    (v7/*: any*/),
    (v32/*: any*/)
  ],
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "headline",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "socialHeadline",
  "storageKey": null
},
v36 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "type": "MAIN_IMAGE"
    }
  }
],
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v38 = [
  (v37/*: any*/)
],
v39 = {
  "alias": "size220x137",
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "style": "220x137"
      }
    }
  ],
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v38/*: any*/),
  "storageKey": "style(filter:{\"style\":\"220x137\"})"
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "duration",
  "storageKey": null
},
v41 = [
  (v9/*: any*/)
],
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "commentCount",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "concreteType": "ArticleSpeech",
  "kind": "LinkedField",
  "name": "articleSpeeches",
  "plural": true,
  "selections": [
    (v37/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "voiceName",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isSlideshow",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "images",
  "plural": true,
  "selections": [
    (v44/*: any*/),
    (v37/*: any*/)
  ],
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flag",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "concreteType": "ArticleTypeSegment",
  "kind": "LinkedField",
  "name": "types",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ArticleType",
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": (v15/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "concreteType": "Topic",
  "kind": "LinkedField",
  "name": "topics",
  "plural": true,
  "selections": (v19/*: any*/),
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "concreteType": "Topic",
  "kind": "LinkedField",
  "name": "topics",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Sponsor",
      "kind": "LinkedField",
      "name": "sponsor",
      "plural": false,
      "selections": [
        (v9/*: any*/),
        (v32/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Image",
          "kind": "LinkedField",
          "name": "images",
          "plural": true,
          "selections": (v38/*: any*/),
          "storageKey": null
        },
        (v7/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shortUrl",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sponsorType",
  "storageKey": null
},
v52 = {
  "kind": "InlineFragment",
  "selections": [
    (v49/*: any*/),
    (v10/*: any*/),
    (v50/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v51/*: any*/)
      ],
      "type": "Article",
      "abstractKey": null
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
},
v53 = [
  (v9/*: any*/),
  (v7/*: any*/)
],
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "published",
  "storageKey": null
},
v55 = {
  "kind": "InlineFragment",
  "selections": [
    (v14/*: any*/),
    (v10/*: any*/),
    (v11/*: any*/),
    (v16/*: any*/),
    (v17/*: any*/),
    (v18/*: any*/),
    (v25/*: any*/)
  ],
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
},
v56 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "text",
    "storageKey": null
  }
],
v57 = [
  (v5/*: any*/),
  {
    "kind": "Literal",
    "name": "contentTypes",
    "value": [
      "VIDEO"
    ]
  },
  {
    "fields": [
      (v6/*: any*/)
    ],
    "kind": "ObjectValue",
    "name": "filter"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": {
      "direction": "DESC",
      "field": "PUBLISHED_DATE"
    }
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "videoPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Section",
        "kind": "LinkedField",
        "name": "section",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "oneLineMenu",
        "args": (v3/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QueueItemsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "entityOnelineMenuLiteQueueItemsEdge"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "items(first:20)"
          }
        ],
        "storageKey": "queue(filter:{\"name\":\"video_highlight_menu\"})"
      },
      {
        "args": [
          {
            "kind": "Literal",
            "name": "withHighlight",
            "value": false
          }
        ],
        "kind": "FragmentSpread",
        "name": "videoHeaderDropdownMenuQuery"
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "videoLatestQueueName",
            "variableName": "videoLatestQueueName"
          }
        ],
        "kind": "FragmentSpread",
        "name": "latestVideoQuery"
      },
      {
        "args": [
          (v5/*: any*/),
          {
            "kind": "Variable",
            "name": "count",
            "variableName": "count"
          },
          (v6/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "videoListQuery"
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "queueName",
            "variableName": "videoShortQueueName"
          }
        ],
        "kind": "FragmentSpread",
        "name": "videoShortCarousel"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "videoPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Section",
        "kind": "LinkedField",
        "name": "section",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v7/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "oneLineMenu",
        "args": (v3/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QueueItemsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v9/*: any*/),
                          (v10/*: any*/)
                        ],
                        "type": "Topic",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v12/*: any*/),
                        "type": "Section",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v12/*: any*/),
                        "type": "VideoSection",
                        "abstractKey": null
                      },
                      (v26/*: any*/),
                      (v21/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "items(first:20)"
          },
          (v7/*: any*/)
        ],
        "storageKey": "queue(filter:{\"name\":\"video_highlight_menu\"})"
      },
      {
        "alias": "videoSeriesMenu",
        "args": [
          {
            "kind": "Literal",
            "name": "filter",
            "value": {
              "name": "video_series_menu"
            }
          }
        ],
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v30/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"video_series_menu\"})"
      },
      {
        "alias": "videoSectionMenu",
        "args": [
          {
            "kind": "Literal",
            "name": "filter",
            "value": {
              "name": "video_sections_menu"
            }
          }
        ],
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v30/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"video_sections_menu\"})"
      },
      {
        "alias": "videoTop",
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "name",
                "variableName": "videoLatestQueueName"
              }
            ],
            "kind": "ObjectValue",
            "name": "filter"
          }
        ],
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 29
              }
            ],
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QueueItemsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v13/*: any*/),
                          (v31/*: any*/),
                          (v33/*: any*/),
                          (v34/*: any*/),
                          (v35/*: any*/),
                          {
                            "alias": null,
                            "args": (v36/*: any*/),
                            "concreteType": "Image",
                            "kind": "LinkedField",
                            "name": "image",
                            "plural": false,
                            "selections": [
                              (v39/*: any*/),
                              {
                                "alias": null,
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "filter",
                                    "value": {
                                      "style": "wide_landscape"
                                    }
                                  }
                                ],
                                "concreteType": "ImageStyle",
                                "kind": "LinkedField",
                                "name": "style",
                                "plural": false,
                                "selections": (v38/*: any*/),
                                "storageKey": "style(filter:{\"style\":\"wide_landscape\"})"
                              }
                            ],
                            "storageKey": "image(filter:{\"type\":\"MAIN_IMAGE\"})"
                          },
                          (v40/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SectionSegmentV2",
                            "kind": "LinkedField",
                            "name": "sectionsV2",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "value",
                                "plural": true,
                                "selections": [
                                  (v8/*: any*/),
                                  {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isSectionUnion"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v41/*: any*/),
                                    "type": "VideoSection",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v41/*: any*/),
                                    "type": "Section",
                                    "abstractKey": null
                                  },
                                  (v26/*: any*/),
                                  (v21/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Topic",
                            "kind": "LinkedField",
                            "name": "topics",
                            "plural": true,
                            "selections": [
                              (v9/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "shortName",
                                "storageKey": null
                              },
                              (v7/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v8/*: any*/),
                                  (v13/*: any*/),
                                  (v14/*: any*/),
                                  (v10/*: any*/),
                                  (v11/*: any*/),
                                  (v16/*: any*/),
                                  (v17/*: any*/),
                                  (v18/*: any*/),
                                  (v25/*: any*/)
                                ],
                                "type": "BaseWithApplicationAndUrlAlias",
                                "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v14/*: any*/),
                              (v10/*: any*/),
                              (v11/*: any*/),
                              (v16/*: any*/),
                              (v17/*: any*/),
                              (v18/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "SectionSegmentV2",
                                    "kind": "LinkedField",
                                    "name": "sectionsV2",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "value",
                                        "plural": true,
                                        "selections": [
                                          (v20/*: any*/),
                                          (v22/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v24/*: any*/)
                                ],
                                "type": "Content",
                                "abstractKey": "__isContent"
                              }
                            ],
                            "type": "BaseWithApplicationAndUrlAlias",
                            "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v42/*: any*/),
                                  (v43/*: any*/),
                                  (v45/*: any*/),
                                  (v46/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "SectionSegmentV2",
                                    "kind": "LinkedField",
                                    "name": "sectionsV2",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "value",
                                        "plural": true,
                                        "selections": [
                                          (v20/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v47/*: any*/),
                                  (v48/*: any*/),
                                  (v52/*: any*/)
                                ],
                                "type": "Article",
                                "abstractKey": null
                              }
                            ],
                            "type": "Content",
                            "abstractKey": "__isContent"
                          }
                        ],
                        "type": "Video",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v34/*: any*/),
                              (v35/*: any*/),
                              (v13/*: any*/),
                              (v10/*: any*/),
                              (v50/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SectionSegmentV2",
                                "kind": "LinkedField",
                                "name": "sectionsV2",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "value",
                                    "plural": true,
                                    "selections": [
                                      (v8/*: any*/),
                                      (v28/*: any*/),
                                      (v29/*: any*/),
                                      (v21/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Topic",
                                "kind": "LinkedField",
                                "name": "topics",
                                "plural": true,
                                "selections": (v53/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "publishedDate",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Author",
                                "kind": "LinkedField",
                                "name": "authors",
                                "plural": true,
                                "selections": (v53/*: any*/),
                                "storageKey": null
                              },
                              (v14/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ArticleTypeSegment",
                                    "kind": "LinkedField",
                                    "name": "types",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ArticleType",
                                        "kind": "LinkedField",
                                        "name": "value",
                                        "plural": true,
                                        "selections": [
                                          (v13/*: any*/),
                                          (v7/*: any*/),
                                          (v9/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "SectionSegmentV2",
                                    "kind": "LinkedField",
                                    "name": "sectionsV2",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "value",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v54/*: any*/),
                                              (v55/*: any*/)
                                            ],
                                            "type": "Section",
                                            "abstractKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "disableOffPlatformContent",
                                    "storageKey": null
                                  },
                                  (v51/*: any*/),
                                  (v54/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Author",
                                    "kind": "LinkedField",
                                    "name": "authors",
                                    "plural": true,
                                    "selections": [
                                      (v13/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v8/*: any*/),
                                          (v14/*: any*/),
                                          (v10/*: any*/),
                                          (v11/*: any*/),
                                          (v16/*: any*/),
                                          (v17/*: any*/),
                                          (v18/*: any*/),
                                          (v25/*: any*/)
                                        ],
                                        "type": "BaseWithApplicationAndUrlAlias",
                                        "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Image",
                                    "kind": "LinkedField",
                                    "name": "images",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": "generic_og",
                                        "args": [
                                          {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                              "style": "og_image_scmp_generic"
                                            }
                                          }
                                        ],
                                        "concreteType": "ImageStyle",
                                        "kind": "LinkedField",
                                        "name": "style",
                                        "plural": false,
                                        "selections": (v38/*: any*/),
                                        "storageKey": "style(filter:{\"style\":\"og_image_scmp_generic\"})"
                                      },
                                      {
                                        "alias": null,
                                        "args": [
                                          {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                              "styles": [
                                                "og_postmag",
                                                "og_image_style",
                                                "og_image_scmp_analysis",
                                                "og_image_scmp_explainer",
                                                "og_image_scmp_editorial",
                                                "og_image_scmp_fact_check",
                                                "og_image_scmp_live",
                                                "og_image_scmp_obituary",
                                                "og_image_scmp_opinion",
                                                "og_image_scmp_review",
                                                "og_image_scmp_series",
                                                "og_image_scmp_generic"
                                              ]
                                            }
                                          }
                                        ],
                                        "concreteType": "ImageStyle",
                                        "kind": "LinkedField",
                                        "name": "styles",
                                        "plural": true,
                                        "selections": [
                                          (v37/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "style",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": "styles(filter:{\"styles\":[\"og_postmag\",\"og_image_style\",\"og_image_scmp_analysis\",\"og_image_scmp_explainer\",\"og_image_scmp_editorial\",\"og_image_scmp_fact_check\",\"og_image_scmp_live\",\"og_image_scmp_obituary\",\"og_image_scmp_opinion\",\"og_image_scmp_review\",\"og_image_scmp_series\",\"og_image_scmp_generic\"]})"
                                      },
                                      (v32/*: any*/),
                                      {
                                        "alias": null,
                                        "args": [
                                          {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                              "style": "768x768"
                                            }
                                          }
                                        ],
                                        "concreteType": "ImageStyle",
                                        "kind": "LinkedField",
                                        "name": "style",
                                        "plural": false,
                                        "selections": (v38/*: any*/),
                                        "storageKey": "style(filter:{\"style\":\"768x768\"})"
                                      },
                                      (v44/*: any*/),
                                      (v37/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "updatedDate",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "FormattedValue",
                                    "kind": "LinkedField",
                                    "name": "summary",
                                    "plural": false,
                                    "selections": (v56/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "FormattedValue",
                                    "kind": "LinkedField",
                                    "name": "subHeadline",
                                    "plural": false,
                                    "selections": (v56/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": [
                                      {
                                        "kind": "Literal",
                                        "name": "customContents",
                                        "value": []
                                      },
                                      {
                                        "kind": "Literal",
                                        "name": "type",
                                        "value": "PARAGRAPH"
                                      }
                                    ],
                                    "concreteType": "FormattedValue",
                                    "kind": "LinkedField",
                                    "name": "body",
                                    "plural": false,
                                    "selections": (v56/*: any*/),
                                    "storageKey": "body(customContents:[],type:\"PARAGRAPH\")"
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "keywords",
                                    "storageKey": null
                                  },
                                  (v48/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "readingTime",
                                    "storageKey": null
                                  },
                                  (v42/*: any*/),
                                  (v43/*: any*/),
                                  (v46/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "sentiment",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Topic",
                                    "kind": "LinkedField",
                                    "name": "firstTopic",
                                    "plural": false,
                                    "selections": (v53/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v49/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Author",
                                            "kind": "LinkedField",
                                            "name": "authors",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "types",
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          },
                                          (v23/*: any*/)
                                        ],
                                        "type": "Article",
                                        "abstractKey": null
                                      }
                                    ],
                                    "type": "Content",
                                    "abstractKey": "__isContent"
                                  }
                                ],
                                "type": "Article",
                                "abstractKey": null
                              }
                            ],
                            "type": "Content",
                            "abstractKey": "__isContent"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SectionSegmentV2",
                                "kind": "LinkedField",
                                "name": "sectionsV2",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "value",
                                    "plural": true,
                                    "selections": [
                                      (v8/*: any*/),
                                      (v28/*: any*/),
                                      (v21/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "Article",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v10/*: any*/),
                                  (v50/*: any*/)
                                ],
                                "type": "Content",
                                "abstractKey": "__isContent"
                              }
                            ],
                            "type": "Video",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Section",
                                "kind": "LinkedField",
                                "name": "fullSectionPath",
                                "plural": true,
                                "selections": [
                                  (v13/*: any*/),
                                  (v9/*: any*/),
                                  (v7/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "Section",
                            "abstractKey": null
                          }
                        ],
                        "type": "BaseWithApplicationAndUrlAlias",
                        "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                      },
                      (v21/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "items(first:29)"
          },
          (v7/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v57/*: any*/),
        "concreteType": "ContentConnection",
        "kind": "LinkedField",
        "name": "contents",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ContentEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v7/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v13/*: any*/),
                      (v34/*: any*/),
                      (v35/*: any*/),
                      {
                        "alias": null,
                        "args": (v36/*: any*/),
                        "concreteType": "Image",
                        "kind": "LinkedField",
                        "name": "image",
                        "plural": false,
                        "selections": [
                          (v39/*: any*/)
                        ],
                        "storageKey": "image(filter:{\"type\":\"MAIN_IMAGE\"})"
                      },
                      (v40/*: any*/),
                      (v55/*: any*/)
                    ],
                    "type": "Video",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v57/*: any*/),
        "filters": [
          "filter",
          "contentTypes",
          "orderBy"
        ],
        "handle": "connection",
        "key": "allVideos_contents",
        "kind": "LinkedHandle",
        "name": "contents"
      },
      {
        "alias": null,
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "name",
                "variableName": "videoShortQueueName"
              }
            ],
            "kind": "ObjectValue",
            "name": "filter"
          }
        ],
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 10
              }
            ],
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QueueItemsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v13/*: any*/),
                          (v34/*: any*/),
                          (v35/*: any*/),
                          (v31/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Image",
                            "kind": "LinkedField",
                            "name": "images",
                            "plural": true,
                            "selections": [
                              {
                                "alias": "portraitStyle",
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "filter",
                                    "value": {
                                      "style": "portrait"
                                    }
                                  }
                                ],
                                "concreteType": "ImageStyle",
                                "kind": "LinkedField",
                                "name": "style",
                                "plural": false,
                                "selections": (v38/*: any*/),
                                "storageKey": "style(filter:{\"style\":\"portrait\"})"
                              }
                            ],
                            "storageKey": null
                          },
                          (v33/*: any*/)
                        ],
                        "type": "Video",
                        "abstractKey": null
                      },
                      (v21/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v13/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v42/*: any*/),
                              (v35/*: any*/),
                              (v34/*: any*/),
                              (v43/*: any*/),
                              (v45/*: any*/),
                              (v46/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SectionSegmentV2",
                                "kind": "LinkedField",
                                "name": "sectionsV2",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "value",
                                    "plural": true,
                                    "selections": [
                                      (v8/*: any*/),
                                      (v20/*: any*/),
                                      (v21/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v47/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Topic",
                                "kind": "LinkedField",
                                "name": "topics",
                                "plural": true,
                                "selections": (v15/*: any*/),
                                "storageKey": null
                              },
                              (v52/*: any*/)
                            ],
                            "type": "Article",
                            "abstractKey": null
                          },
                          (v55/*: any*/)
                        ],
                        "type": "Content",
                        "abstractKey": "__isContent"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "items(first:10)"
          },
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3a3a4a0c0f1e4c335bdbb370ed80777b",
    "id": null,
    "metadata": {},
    "name": "videoPageQuery",
    "operationKind": "query",
    "text": "query videoPageQuery(\n  $after: String\n  $count: Int = 24\n  $entityId: String!\n  $sectionIds: [String]\n  $videoLatestQueueName: String!\n  $videoShortQueueName: String!\n) {\n  section(filter: {entityId: $entityId}) {\n    advertZone(version: 2)\n    id\n  }\n  oneLineMenu: queue(filter: {name: \"video_highlight_menu\"}) {\n    items(first: 20) {\n      edges {\n        ...entityOnelineMenuLiteQueueItemsEdge\n      }\n    }\n    id\n  }\n  ...videoHeaderDropdownMenuQuery_4eBY9P\n  ...latestVideoQuery_29kcpA\n  ...videoListQuery_1vC9Q5\n  ...videoShortCarousel_1ET35F\n}\n\nfragment actionWidgetContent on Content {\n  __isContent: __typename\n  __typename\n  entityId\n  ... on Article {\n    ...articleCommentsTriggerArticle\n    ...articlePrintArticle\n  }\n  ...entityLink\n}\n\nfragment articleCommentsTriggerArticle on Article {\n  commentCount\n  entityId\n  ...helpersUseContentSponsorContent\n}\n\nfragment articleHeadlineHeaderFeaturesContent on Content {\n  __isContent: __typename\n  headline\n  socialHeadline\n}\n\nfragment articlePrintArticle on Article {\n  ...contentShareWidgetContent\n}\n\nfragment articleSeoArticle_3boCng on Article {\n  ...hooksArticleSeoArticle\n  ...helpersGetArticleTypeArticle\n  entityId\n  publishedDate\n  updatedDate\n  summary {\n    text\n  }\n  subHeadline {\n    text\n  }\n  body(customContents: [], type: PARAGRAPH) {\n    text\n  }\n  keywords\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        name\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  topics {\n    name\n    entityId\n    id\n  }\n  urlAlias\n  authors {\n    name\n    id\n  }\n  images {\n    style(filter: {style: \"768x768\"}) {\n      url\n    }\n  }\n  readingTime\n}\n\nfragment articleShareWidgetArticle on Article {\n  ...contentShareWidgetContent\n  ...articleCommentsTriggerArticle\n  ...articleSpeechInlineWidgetArticle\n}\n\nfragment articleSpeechInlineWidgetArticle on Article {\n  ...genericArticleSpeechInlineWidgetGenericArticle\n  ...utilitiesGetHasArticleSpeechArticle\n}\n\nfragment atomsCurrentArticleAtomBase_3boCng on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  ... on Content {\n    __isContent: __typename\n    ...articleHeadlineHeaderFeaturesContent\n    ...articleSeoArticle_3boCng\n    ...articleShareWidgetArticle\n    ...bookmarkHeaderFeaturesContent\n    ...commentHeaderFeaturesArticle\n    ...contentShareWidgetContent\n    ...helpersCheckIsStyleArticle\n    ...helpersUseSharingUrl\n    ...hooksContentInterestArticle\n    ...hooksTrackPageViewArticle\n    ...hooksUseCurrentArticleIdsArticle\n    ...hooksUseCurrentArticlePrebidConfigArticle\n    ...hooksUsePageTargetingArticle\n    ...onboardingNewsletterSubscriptionArticle\n    ...entityLinkHeaderFeaturesArticle\n    ...shareHeaderFeaturesContent\n    ...helpersRosettaArticleContextArticle\n  }\n}\n\nfragment atomsCurrentShareContentAtomBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  ... on Article {\n    ...contentShareWidgetContent\n  }\n  ... on Video {\n    ...contentShareWidgetContent\n  }\n}\n\nfragment atomsCurrentStyleCardCarouselWidgetSectionsAtomBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  ... on Article {\n    sectionsV2 {\n      value {\n        __typename\n        ... on Section {\n          entityId\n          name\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n  }\n  ... on Section {\n    fullSectionPath {\n      entityId\n      name\n      id\n    }\n  }\n}\n\nfragment atomsCurrentTakeoverAdSectionsAtomBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  ... on Article {\n    sectionsV2 {\n      value {\n        __typename\n        ... on Section {\n          entityId\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n  }\n  ... on Section {\n    fullSectionPath {\n      entityId\n      id\n    }\n  }\n}\n\nfragment bookmarkHeaderFeaturesContent on Content {\n  __isContent: __typename\n  entityId\n}\n\nfragment buttonArticleSpeechInlineWidgetGenericButtonArticle on Article {\n  entityId\n  socialHeadline\n  headline\n  articleSpeeches {\n    url\n    voiceName\n  }\n  images {\n    isSlideshow\n    url\n  }\n}\n\nfragment commentHeaderFeaturesArticle on Article {\n  ...articleCommentsTriggerArticle\n}\n\nfragment contentShareWidgetContent on Content {\n  __isContent: __typename\n  __typename\n  entityId\n  urlAlias\n  shortUrl\n  socialHeadline\n  headline\n  ... on Video {\n    youtubeId\n  }\n}\n\nfragment entityLink on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  entityId\n  entityUuid\n  urlAlias\n  urlRedirect {\n    toUrl\n    id\n  }\n  application {\n    entityId\n    id\n  }\n  ... on Section {\n    fullSectionPath {\n      entityId\n      id\n    }\n    parentSection\n  }\n  ...helpersAppBarVariantBase\n  ...helpersApplicationBase\n  ...helpersCheckIsPlusArticle\n  ...helpersStyleSectionContent\n}\n\nfragment entityLinkHeaderFeaturesArticle on Article {\n  authors {\n    name\n    ...entityLink\n    id\n  }\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        name\n        published\n        ...entityLink\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment entityOnelineMenuLiteQueueItemsEdge on QueueItemsEdge {\n  node {\n    __typename\n    ... on Topic {\n      name\n      urlAlias\n    }\n    ... on Section {\n      name\n      urlAlias\n      urlRedirect {\n        toUrl\n        id\n      }\n    }\n    ... on VideoSection {\n      name\n      urlAlias\n      urlRedirect {\n        toUrl\n        id\n      }\n    }\n    ...entityLink\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment genericArticleSpeechInlineWidgetGenericArticle on Article {\n  entityId\n  ...buttonArticleSpeechInlineWidgetGenericButtonArticle\n  ...hooksShowGenericInlineWidgetByArticleArticle\n  ...toolTipArticleSpeechWidgetToolTipArticle\n  ...utilitiesGetHasArticleSpeechArticle\n}\n\nfragment helpersAppBarVariantBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  ...helpersCheckIsLiveArticle\n  ...helpersCheckIsPlusPage\n  ...helpersCheckIsPostMagazineArticle\n  ...helpersCheckIsStyleArticle\n  ...helpersSectionContent\n  ...helpersStyleSectionContent\n}\n\nfragment helpersApplicationBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  ...helpersCheckIsPlusPage\n}\n\nfragment helpersCheckIfNewsSectionInFirstIndexSection on SectionUnion {\n  __isSectionUnion: __typename\n  ... on Section {\n    name\n  }\n  ... on VideoSection {\n    name\n  }\n}\n\nfragment helpersCheckIsAmpEnabledArticle on Article {\n  entityId\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  disableOffPlatformContent\n  sponsorType\n  published\n  ...helpersCheckIsPlusArticle\n}\n\nfragment helpersCheckIsLiveArticle on Article {\n  flattenTypeIds\n  liveArticle {\n    status\n    id\n  }\n}\n\nfragment helpersCheckIsMainTopicContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    id\n  }\n}\n\nfragment helpersCheckIsPlusArticle on Content {\n  __isContent: __typename\n  ... on Article {\n    paywallTypes {\n      entityUuid\n      id\n    }\n  }\n}\n\nfragment helpersCheckIsPlusPage on Page {\n  urlAlias\n}\n\nfragment helpersCheckIsPostMagazineArticle on Content {\n  __isContent: __typename\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment helpersCheckIsStyleArticle on Content {\n  __isContent: __typename\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on VideoSection {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment helpersGetArticleTypeArticle on Content {\n  __isContent: __typename\n  ... on Article {\n    types {\n      value {\n        entityId\n        id\n      }\n    }\n  }\n}\n\nfragment helpersGetVideoYoutubeIdVideo on Video {\n  youtubeId\n  videoSource {\n    id\n    type\n  }\n}\n\nfragment helpersRosettaArticleContextArticle on Content {\n  __isContent: __typename\n  topics {\n    name\n    id\n  }\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        name\n      }\n      ... on VideoSection {\n        name\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment helpersSanitizeArticleTypeEntityIdsArticle on Article {\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersSanitizeAuthorTypesArticle on Article {\n  authors {\n    types\n    id\n  }\n}\n\nfragment helpersSanitizedAuthorEntityIdsArticle on Article {\n  authors {\n    entityId\n    id\n  }\n}\n\nfragment helpersSectionContent on Section {\n  fullSectionPath {\n    entityId\n    id\n  }\n}\n\nfragment helpersStyleSectionContent on Section {\n  fullSectionPath {\n    entityId\n    id\n  }\n}\n\nfragment helpersUseContentSponsorContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    sponsor {\n      ...sponsorTagSponsor\n      name\n      type\n      id\n    }\n    id\n  }\n  ... on Article {\n    sponsorType\n  }\n  ...helpersCheckIsMainTopicContent\n}\n\nfragment helpersUseSharingUrl on Content {\n  __isContent: __typename\n  urlAlias\n}\n\nfragment hooksArticleSeoArticle on Article {\n  ...helpersCheckIsPostMagazineArticle\n  ...helpersCheckIsStyleArticle\n  ...hooksContentHeadlineTagContent\n  ...helpersCheckIsAmpEnabledArticle\n  entityId\n  headline\n  socialHeadline\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n  authors {\n    entityId\n    id\n  }\n  images {\n    generic_og: style(filter: {style: \"og_image_scmp_generic\"}) {\n      url\n    }\n    styles(filter: {styles: [\"og_postmag\", \"og_image_style\", \"og_image_scmp_analysis\", \"og_image_scmp_explainer\", \"og_image_scmp_editorial\", \"og_image_scmp_fact_check\", \"og_image_scmp_live\", \"og_image_scmp_obituary\", \"og_image_scmp_opinion\", \"og_image_scmp_review\", \"og_image_scmp_series\", \"og_image_scmp_generic\"]}) {\n      url\n      style\n    }\n    type\n  }\n  urlAlias\n}\n\nfragment hooksContentHeadlineTagContent on Content {\n  __isContent: __typename\n  __typename\n  ... on Article {\n    types {\n      value {\n        name\n        entityId\n        id\n      }\n    }\n    ...helpersCheckIsStyleArticle\n  }\n  flag\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        name\n      }\n      ... on VideoSection {\n        name\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  ...hooksContentHelperContent\n}\n\nfragment hooksContentHelperContent on Content {\n  __isContent: __typename\n  ...helpersSanitizeArticleTypeEntityIdsArticle\n  ...helpersSanitizeAuthorTypesArticle\n  ...helpersSanitizedAuthorEntityIdsArticle\n  flag\n}\n\nfragment hooksContentInterestArticle on Content {\n  __isContent: __typename\n  __typename\n  entityId\n  urlAlias\n  topics {\n    name\n    id\n  }\n  ... on Article {\n    sentiment\n    types {\n      value {\n        name\n        id\n      }\n    }\n  }\n}\n\nfragment hooksPaywallPromiseContent on Content {\n  __isContent: __typename\n  entityId\n}\n\nfragment hooksShowGenericInlineWidgetByArticleArticle on Article {\n  ...hooksPaywallPromiseContent\n  entityId\n  flag\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n  topics {\n    entityId\n    id\n  }\n}\n\nfragment hooksTrackCurrentItemBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  ...atomsCurrentArticleAtomBase_3boCng\n  ...atomsCurrentShareContentAtomBase\n  ...atomsCurrentStyleCardCarouselWidgetSectionsAtomBase\n  ...atomsCurrentTakeoverAdSectionsAtomBase\n}\n\nfragment hooksTrackPageViewArticle on Content {\n  __isContent: __typename\n  entityId\n  publishedDate\n  headline\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        name\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  urlAlias\n  authors {\n    name\n    id\n  }\n  entityUuid\n  ... on Article {\n    types {\n      value {\n        name\n        id\n      }\n    }\n  }\n}\n\nfragment hooksUseCurrentArticleIdsArticle on Content {\n  __isContent: __typename\n  entityId\n  entityUuid\n}\n\nfragment hooksUseCurrentArticlePrebidConfigArticle on Article {\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n        name\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  topics {\n    name\n    id\n  }\n}\n\nfragment hooksUsePageTargetingArticle on Article {\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        name\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  firstTopic {\n    name\n    id\n  }\n}\n\nfragment itemVideoUpNextWidgetItemVideo on Video {\n  entityId\n  duration\n  headline\n  socialHeadline\n  image(filter: {type: MAIN_IMAGE}) {\n    style(filter: {style: \"wide_landscape\"}) {\n      url\n    }\n  }\n}\n\nfragment latestVideoQuery_29kcpA on Query {\n  videoTop: queue(filter: {name: $videoLatestQueueName}) {\n    items(first: 29) {\n      edges {\n        node {\n          __typename\n          ... on Video {\n            entityId\n            ...helpersGetVideoYoutubeIdVideo\n            ...videoListGridCardContent\n            ...videoPrimaryContent\n          }\n          ...hooksTrackCurrentItemBase\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        ...videoUpNextWidgetVideo\n      }\n    }\n    id\n  }\n}\n\nfragment onboardingNewsletterSubscriptionArticle on Article {\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment popupArticle20ShareMenuContent on Content {\n  __isContent: __typename\n  ...articleShareWidgetArticle\n}\n\nfragment shareArticle20Content on Content {\n  __isContent: __typename\n  ...popupArticle20ShareMenuContent\n}\n\nfragment shareHeaderFeaturesContent on Content {\n  __isContent: __typename\n  ...shareArticle20Content\n}\n\nfragment sponsorTagSponsor on Sponsor {\n  name\n  type\n  images {\n    url\n  }\n}\n\nfragment toolTipArticleSpeechWidgetToolTipArticle on Article {\n  entityId\n}\n\nfragment topicLinkTopic on Topic {\n  ...entityLink\n  name\n  shortName\n}\n\nfragment utilitiesGetHasArticleSpeechArticle on Article {\n  articleSpeeches {\n    url\n  }\n}\n\nfragment videoHeaderDropdownMenuQuery_4eBY9P on Query {\n  videoSeriesMenu: queue(filter: {name: \"video_series_menu\"}) {\n    items(first: 20) {\n      edges {\n        node {\n          __typename\n          ... on Section {\n            entityId\n            name\n          }\n          ... on Topic {\n            entityId\n            name\n          }\n          ... on VideoSection {\n            entityId\n            name\n          }\n          ...entityLink\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n  videoSectionMenu: queue(filter: {name: \"video_sections_menu\"}) {\n    items(first: 20) {\n      edges {\n        node {\n          __typename\n          ... on Section {\n            entityId\n            name\n          }\n          ... on Topic {\n            entityId\n            name\n          }\n          ... on VideoSection {\n            entityId\n            name\n          }\n          ...entityLink\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment videoListGridCardContent on Video {\n  headline\n  socialHeadline\n  image(filter: {type: MAIN_IMAGE}) {\n    size220x137: style(filter: {style: \"220x137\"}) {\n      url\n    }\n  }\n  duration\n  ...entityLink\n}\n\nfragment videoListGridQuery_1vC9Q5 on Query {\n  contents(after: $after, first: $count, filter: {sectionIds: $sectionIds}, contentTypes: [VIDEO], orderBy: {field: PUBLISHED_DATE, direction: DESC}) {\n    edges {\n      node {\n        __typename\n        ... on Video {\n          entityId\n          ...videoListGridCardContent\n        }\n        id\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment videoListQuery_1vC9Q5 on Query {\n  ...videoListGridQuery_1vC9Q5\n}\n\nfragment videoPrimaryContent on Video {\n  entityId\n  headline\n  socialHeadline\n  image(filter: {type: MAIN_IMAGE}) {\n    style(filter: {style: \"wide_landscape\"}) {\n      url\n    }\n  }\n  sectionsV2 {\n    value {\n      __typename\n      ... on VideoSection {\n        name\n      }\n      ...helpersCheckIfNewsSectionInFirstIndexSection\n      ...entityLink\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  topics {\n    ...topicLinkTopic\n    id\n  }\n  ...actionWidgetContent\n  ...entityLink\n  ...helpersGetVideoYoutubeIdVideo\n  ...shareArticle20Content\n}\n\nfragment videoShortCarouselCard on Video {\n  entityId\n  headline\n  socialHeadline\n  youtubeId\n  images {\n    portraitStyle: style(filter: {style: \"portrait\"}) {\n      url\n    }\n  }\n  ...helpersGetVideoYoutubeIdVideo\n}\n\nfragment videoShortCarouselPlayerContent on Content {\n  __isContent: __typename\n  ... on Video {\n    entityId\n    headline\n    ...helpersGetVideoYoutubeIdVideo\n  }\n  ...actionWidgetContent\n  ...entityLink\n  ...shareArticle20Content\n}\n\nfragment videoShortCarouselPlayerModal on QueueItemsEdge {\n  node {\n    __typename\n    ... on Video {\n      entityId\n    }\n    ...videoShortCarouselPlayerContent\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment videoShortCarousel_1ET35F on Query {\n  queue(filter: {name: $videoShortQueueName}) {\n    items(first: 10) {\n      edges {\n        node {\n          __typename\n          ...videoShortCarouselCard\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        ...videoShortCarouselPlayerModal\n      }\n    }\n    id\n  }\n}\n\nfragment videoUpNextWidgetVideo on QueueItemsEdge {\n  node {\n    __typename\n    ... on Video {\n      entityId\n      ...itemVideoUpNextWidgetItemVideo\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a9e9b3da4a5c6405c2279ecaa0282017";

export default node;
